import { render } from "./commonForm.vue?vue&type=template&id=63b3007a&ts=true"
import script from "./commonForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonForm.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/commonControls/commonForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63b3007a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63b3007a', __exports__)) {
    api.reload('63b3007a', __exports__)
  }
  
  module.hot.accept("./commonForm.vue?vue&type=template&id=63b3007a&ts=true", () => {
    api.rerender('63b3007a', render)
  })

}


export default __exports__